var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import DefaultPopup from '../defaultPopup';
import * as ST from './styled';
export var EResultPopupStatus;
(function (EResultPopupStatus) {
    EResultPopupStatus["SUCCESS"] = "success";
    EResultPopupStatus["ERROR"] = "error";
    EResultPopupStatus["WARNING"] = "warning";
    EResultPopupStatus["DEFAULT"] = "default";
})(EResultPopupStatus || (EResultPopupStatus = {}));
var resultIconTypes = (_a = {},
    _a[EResultPopupStatus.SUCCESS] = {
        iconPath: require('../../../assets/img/icons/statuses/popup/success.svg'),
        iconAlt: 'Успех',
    },
    _a[EResultPopupStatus.ERROR] = {
        iconPath: require('../../../assets/img/icons/statuses/popup/error.svg'),
        iconAlt: 'Ошибка',
    },
    _a[EResultPopupStatus.WARNING] = {
        iconPath: require('../../../assets/img/icons/statuses/popup/warning.svg'),
        iconAlt: 'Предупреждение',
    },
    _a[EResultPopupStatus.DEFAULT] = {
        iconPath: '',
        iconAlt: '',
    },
    _a);
var PopupResult = function (_a) {
    var title = _a.title, text = _a.text, _b = _a.type, type = _b === void 0 ? EResultPopupStatus.DEFAULT : _b, children = _a.children, props = __rest(_a, ["title", "text", "type", "children"]);
    var isTitleString = typeof title === 'string';
    var isTextString = typeof text === 'string';
    var _c = resultIconTypes[type || EResultPopupStatus.DEFAULT], iconPath = _c.iconPath, iconAlt = _c.iconAlt;
    return (<DefaultPopup {...props}>
            <ST.Container>
                {!!iconPath && (<ST.Icon src={iconPath} alt={iconAlt} data-test='popup-result-icon'/>)}
                {title &&
            <ST.Title isIcon={!!iconPath} data-test='popup-result-title'>
                        {isTitleString
                    ? <p>{title}</p>
                    : title}
                    </ST.Title>}
                {text &&
            <ST.Text data-test='popup-result-text'>
                        {isTextString
                    ? <p>{text}</p>
                    : text}
                    </ST.Text>}
                {children &&
            <ST.Content>{children}</ST.Content>}
            </ST.Container>
        </DefaultPopup>);
};
export default PopupResult;
